export { Fetch as default } from '@warp-drive/core';
